import config from "@genai/config";
import { OktaAuth } from "@okta/okta-auth-js";
import { Tokens } from "../model";

const authClient = new OktaAuth({
  issuer: config.oktaIssuer,
  clientId: config.oktaClientId,
  redirectUri: config.redirectUrl,
  scopes: ["openid", "profile", "email"],
});

export const getTokensOrLogin = async (): Promise<Tokens | void> => {
  await authenticate();
  return getTokensSync();
};

export const authenticate = async (): Promise<{ authenticated: boolean }> => {
  const accessToken = authClient.getAccessToken();
  const idToken = authClient.getIdToken();
  const isAuthenticated = await authClient.isAuthenticated({
    onExpiredToken: "renew",
  });
  if (accessToken && idToken && isAuthenticated) {
    return {
      authenticated: true,
    };
  }
  if (authClient.isLoginRedirect()) {
    const authData = await authClient.token.parseFromUrl();
    const { accessToken, idToken } = authData.tokens;
    if (!accessToken || !idToken) {
      await authClient.token.getWithRedirect({
        responseType: ["id_token"],
      });
      return {
        authenticated: false,
      };
    }
    await authClient.tokenManager.add("accessToken", accessToken);
    await authClient.tokenManager.add("idToken", idToken);
    return {
      authenticated: true,
    };
  }
  await authClient.token.getWithRedirect({
    responseType: ["id_token"],
  });

  return {
    authenticated: false,
  };
};

export const getTokensSync = (): Tokens | undefined => {
  const accessToken = authClient.getAccessToken();
  const idToken = authClient.getIdToken();
  if (accessToken && idToken) {
    return {
      accessToken,
      idToken,
    };
  }
  return undefined;
};

export const getUserInfo = async () => {
  return authClient.getUser();
};

export const logout = async () => {
  authClient.tokenManager.clear();
  return authClient.signOut();
};
